/*
 *
 * HeyLightPopup
 *
 * @version 1.0.0
 * @author Giorgia Cuozzo
 * @since 04-Feb-2025
*/

import { connect } from 'react-redux'
// import { bindActionCreators } from 'redux'
import HeyLightPopup from './HeyLightPopup'
import { doHidePopup } from 'Store/actions/popup'

const mapDispatchToProps = dispatch => ({
  doHidePopup: () => dispatch(doHidePopup())
})

const mapStateToProps = () => ({

})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(HeyLightPopup)
